// src/pages/MALoginPage.js

import React, { useEffect, useState } from 'react';
import Logo from '../components/Logo';
import { authApi } from '../axiosInstance';

export default function MALoginPage() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // CSRF priming
  useEffect(() => {
    authApi.get('/csrf-token', { withCredentials: true }).catch(() => {});
  }, []);

  async function handleLogin(e) {
    e.preventDefault();
    if (submitting) return;

    setErrorMessage('');
    setSubmitting(true);

    try {
      const emailNorm = (email || '').trim().toLowerCase();

      // 1) CSRF-Token holen
      let token = '';
      try {
        const { data } = await authApi.get('/csrf-token', { withCredentials: true });
        token = data?.csrfToken || '';
      } catch { /* */ }

      // 2) Login call
      const loginRes = await authApi.post(
        '/login',
        { email: emailNorm, password },
        {
          withCredentials: true,
          headers: { 'X-CSRF-Token': token, 'X-Requested-With': 'XMLHttpRequest' },
        }
      );

      // 3) Rollen-Check: nur employee erlaubt
      const userRole = loginRes.data?.role || '';
      if (userRole !== 'employee') {
        setErrorMessage('Dieser Login ist für Mitarbeiter. Bitte nutzen Sie den entsprechenden Login-Bereich.');
        return;
      }

      window.location.href = '/#/ma-dashboard';
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setErrorMessage('E-Mail oder Passwort falsch.');
      } else {
        setErrorMessage('Anmeldung fehlgeschlagen. Bitte erneut versuchen.');
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center p-6 text-white">
      <div className="mb-10">
        <Logo variant="wordmark" size="xxxl" />
      </div>

      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold mb-2">Mitarbeiter-Login</h2>
        <p className="text-gray-400 text-sm">Kulturumfrage und Check-ins</p>
      </div>

      {errorMessage && (
        <div className="bg-red-600 text-white px-4 py-2 rounded-2xl mb-6">
          {errorMessage}
        </div>
      )}

      <form
        onSubmit={handleLogin}
        className="bg-gray-800 p-8 rounded-2xl shadow-md w-full max-w-md"
      >
        <div className="mb-6">
          <label className="block mb-2 font-semibold">E-Mail</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full p-3 rounded bg-gray-700 text-white focus:outline-none"
            placeholder="name@firma.de"
            autoComplete="username"
          />
        </div>

        <div className="mb-6">
          <label className="block mb-2 font-semibold">Passwort</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full p-3 rounded bg-gray-700 text-white focus:outline-none"
            placeholder="••••••••"
            autoComplete="current-password"
          />
        </div>

        <button
          type="submit"
          disabled={submitting}
          className={`w-full ${
            submitting ? 'opacity-70 cursor-not-allowed' : 'bg-mentixxgreen hover:bg-green-400'
          } text-black font-bold py-3 rounded-2xl transition`}
        >
          {submitting ? 'Wird angemeldet…' : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
